<template>
    <div id="settings">
        <p>Settings.</p>

        <vue-tags-input
                v-model="tag"
                :tags="tags"
                :autocomplete-items="filteredItems"
                @tags-changed="newTags => tags = newTags"
        />

    </div>
</template>

<script>
    import VueTagsInput from '@johmun/vue-tags-input';

    export default {
        name: 'settings',
        components: {
            VueTagsInput,
        },
        data() {
            return {
                tag: '',
                tags: [],
                autocompleteItems: [{
                    text: 'Spain',
                }, {
                    text: 'France',
                }, {
                    text: 'USA',
                }, {
                    text: 'Germany',
                }, {
                    text: 'China',
                }],
            };
        },
        computed: {
            filteredItems() {
                return this.autocompleteItems.filter(i => {
                    return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
                });
            },
        },
    }
</script>